import { render, staticRenderFns } from "./Widgets.vue?vue&type=template&id=1a2c8a20&"
import script from "./Widgets.vue?vue&type=script&lang=js&"
export * from "./Widgets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a2c8a20')) {
      api.createRecord('1a2c8a20', component.options)
    } else {
      api.reload('1a2c8a20', component.options)
    }
    module.hot.accept("./Widgets.vue?vue&type=template&id=1a2c8a20&", function () {
      api.rerender('1a2c8a20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Dashboard/Widgets.vue"
export default component.exports